import React from "react";

import Container from "react-bootstrap/Container";

import PageBlock from "./PageBlock";

function Arbeiten() {
  return (
    <div>
      <Container className="h-100" fluid>
        <PageBlock source="pages/themen/konstruktion.md" title={<><div>Architektur</div><div>+ Umwelt</div></>} />
        <PageBlock />
        <PageBlock source="pages/themen/umwelt.md" title={<><div>Wissenschaft</div><div>+ Wahrnehmung</div></>} />
        <PageBlock />
        <PageBlock source="pages/themen/kunst.md" title={<><div>Kunst</div><div>+ Literatur</div></>} />
      </Container>
    </div>
  );
}

export default Arbeiten;
